import { render, staticRenderFns } from "./userBossListTable.vue?vue&type=template&id=3de99197"
import script from "./userBossListTable.vue?vue&type=script&lang=js"
export * from "./userBossListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports